import React from "react";

export default function ImageCircle(props) {
  return (
    <div className="flex flex-col justify-center items-center gap-[14px]">
      {props.item.icon.attributes && (
        <img
          className="cursor-pointer h-[100px] w-[100px] xl:h-[132px] xl:w-[132px]"
          src={`${process.env.REACT_APP_API_URL}${props.item.icon.attributes.url}`}
          alt=""
        />
      )}
      <h1 className="cursor-pointer text-[20px] xl:text-[24px] font-medium text-darkGray2 mt-[25px]">
        {props.lang === "th"
          ? props.item.link.label_TH
          : props.item.link.label_EN}
      </h1>
    </div>
  );
}
